import { InstacarAppLanguage } from "@instacover/instacar-database/browser"
import { Suspense } from "react"

import { lazyWithRetry } from "../../utils/react"

const CzFlag = lazyWithRetry(() => import("../../images/icons/flags/cz.svg?react"), "CzFlag")
const SkFlag = lazyWithRetry(() => import("../../images/icons/flags/sk.svg?react"), "SkFlag")
const GBFlag = lazyWithRetry(() => import("../../images/icons/flags/gb.svg?react"), "GBFlag")
const GeFlag = lazyWithRetry(() => import("../../images/icons/flags/ge.svg?react"), "GeFlag")
const HuFlag = lazyWithRetry(() => import("../../images/icons/flags/hu.svg?react"), "HuFlag")
const DeFlag = lazyWithRetry(() => import("../../images/icons/flags/de.svg?react"), "DeFlag")
const EsFlag = lazyWithRetry(() => import("../../images/icons/flags/es.svg?react"), "EsFlag")
const PlFlag = lazyWithRetry(() => import("../../images/icons/flags/pl.svg?react"), "PlFlag")
const FrFlag = lazyWithRetry(() => import("../../images/icons/flags/fr.svg?react"), "FrFlag")
const LuFlag = lazyWithRetry(() => import("../../images/icons/flags/lu.svg?react"), "LuFlag")
const PtFlag = lazyWithRetry(() => import("../../images/icons/flags/pt.svg?react"), "PtFlag")

const FLAGS: Record<InstacarAppLanguage, typeof CzFlag> = {
  cs: CzFlag,
  sk: SkFlag,
  en: GBFlag,
  ka: GeFlag,
  hu: HuFlag,
  de: DeFlag,
  es: EsFlag,
  pl: PlFlag,
  fr: FrFlag,
  lb: LuFlag,
  pt: PtFlag,
}

export async function preloadFlags(languages: readonly InstacarAppLanguage[]) {
  await Promise.allSettled(languages.map((language) => FLAGS[language].preload?.()))
}

type Props = {
  language: InstacarAppLanguage
  width?: number
}

export function FlagIcon(props: Props) {
  const width = props.width ?? 25

  const FlagComponent = FLAGS[props.language]
  if (!FlagComponent) {
    return null
  }

  // Flags are lazy chunks. A local boundary keeps a click-opened dropdown from suspending the whole route
  return (
    <Suspense fallback={<span className="block shrink-0" style={{ width, height: width }} />}>
      <FlagComponent width={width} />
    </Suspense>
  )
}
